const getter = {
    drawingId: (state: any) => state.drawingConfig.drawingId,
    drawingConfig: (state: any) => state.drawingConfig,
    brDrawingUrl: (state: any) => state.drawingConfig.brDrawingUrl,
    projectId: (state: any) => state.projectConfig.projectId,
    projectName: (state: any) => state.projectConfig.projectName,
    displaySetting: (state: any) => state.displaySetting,
    hasPermission: (state: any) => state.commonConfig.hasPermission,
    getSaveTime: (state:any) => {
        return new Date(state.saveTime.time).format('hh:mm');
    }
};
export default getter;
